import React, { useState } from "react";

import NurseAddition from "./NurseAddition";
import NurseList from "./NurseList";

/**
 * Nurse Management — add form on top, list below, same as the User Management
 * and Doctor Management screens. The refresh counter lives here rather than
 * using App.js's shared `refreshList`, so adding a nurse only re-lists this
 * screen (see BedManagement for the same reasoning).
 */
function NurseManagement() {
  const [refreshList, setRefreshList] = useState(0);

  return (
    <div>
      <NurseAddition updateList={() => setRefreshList((n) => n + 1)} />
      <NurseList refreshList={refreshList} />
    </div>
  );
}

export default NurseManagement;
